import usersTemplate from './users.html';

const MAX_LOCATION_USERS = 100;
const SELECTED_USER_LOCAL_STORAGE_KEY = 'Selected-User';
const SELECTED_CALLCENTER_LOCAL_STORAGE_KEY = 'Selected-CallCenter';

// Search users form settings (IDs from userLookup.directive.html)
const SEARCH_USER_FORM_ID = 'form-user-search';
const SEARCH_USER_INPUT_ID = 'input-user-search';
/**
 * Max number of user results
 * @type {number}
 */
const SEARCH_USER_LIMIT = 10;

export default angular
  .module('main.locations.edit.tabs.users', [])

  .directive('editLocationUsersTab', () => {
    return {
      restrict: 'E',
      template: usersTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $state,
                   $filter,
                   utils,
                   config,
                   EditLocationDataProvider,
                   PermissionsService,
                   $timeout
      ) => {
        $scope.dataProvider = EditLocationDataProvider.instance;
        const $t = $filter('translate');

        // Maximum number of users allowed
        $scope.maxLocationUsers = MAX_LOCATION_USERS;

        // Users search scrolling
        $scope.scrollFix = false;
        $scope.hideSearchHint = false;

        $scope.locationCategories = config.getConfigByKey('locationCategories');
        $scope.locationAccessTypes = config.getConfigByKey('locationAccessLevels');
        $scope.callCenterStatuses = config.getConfigByKey('callCenterStatuses');
        $scope.locationUserRoles = config.getConfigByKey('locationUserRoles');

        // Users list grooping
        $scope.availableGroupings = config.getConfigByKey('userListGroupTypes');
        $scope.selectedGrouping = $scope.availableGroupings[1].id;

        angular.extend($scope, {
          searchUsers: searchUsers,
          addUser: addUser,
          isUserEditable: isUserEditable,
          onEditCallCenterButtonClick: onEditCallCenterButtonClick,
          onAddUserButtonClick: onAddUserButtonClick,
          onEditUserButtonClick: onEditUserButtonClick,
          onRemoveUserButtonClick: onRemoveUserButtonClick,
          onConfigureUserAccessButtonClick: onConfigureUserAccessButtonClick,
          onSaveAccessConfigButtonClick: onSaveAccessConfigButtonClick,
          getUserAccessDetails: getUserAccessDetails,
          copyToClipboard: $rootScope.copyToClipboard,
          initSortableCaregiversList: initSortableCaregiversList
        });

        init();

        function init() {
          $scope.loading = true;
          initWatchers();

          $q.all([
            $scope.dataProvider.locationIdResource.init(),
            $scope.dataProvider.locationUsersResource.init(),
            $scope.dataProvider.locationAdminUsersResource.init(),
            $scope.dataProvider.locationOtherUsersResource.init(),
            $scope.dataProvider.locationCallCenterResource.init()
          ])
            .then(() => {
              // Watch for call center resource changes (subscriptions)
              $scope.$watchGroup([
                'dataProvider.locationCallCenterResource.value',
                'dataProvider.locationUsersResource.value',
              ], () => {
                initViewModel();
              });
              $scope.loading = false;
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initSortableCaregiversList() {
          $timeout(() => {
            // Sortable grouped users list (caregivers)
            $('#caregivers-list').sortable({
              placeholder: 'sortable-list-placeholder',
              cursor: 'grabbing',
              opacity: 0.8,
              update: function(event, ui) {
                $scope.$applyAsync(() => {
                  const sortedIndexes = $('#caregivers-list').sortable('toArray'); // e.g. ['3', '1', '2']
                  $scope.locationUsers[1].users.sort((a, b) => (a.callOrder || 0) - (b.callOrder || 0));
                  $scope.locationUsers[1].users = sortedIndexes
                    .map(indexStr => $scope.locationUsers[1].users[parseInt(indexStr)]);

                  return $scope.dataProvider.updateLocationUsersOrder($scope.locationUsers[1].users);
                });
              }
            });
          }, 100);
        }

        function initWatchers() {
          $scope.$on('$destroy', () => {
            $('#user-access-modal').remove();
          });
        }

        function initViewModel() {
          // Get MMS number
          $scope.dataProvider.getMMSNumber()
            .then(data => {
              if (data) {
                $scope.mmsNumber = data;
              }
            });

          // Location users for grouping by role
          const locationUsers = angular.copy($scope.dataProvider.locationUsersResource.value) || [];
          $scope.locationUsers = config.getConfigByKey('userListGroups');
          locationUsers.forEach(user => {
            let index = $scope.locationUsers.findIndex(u => u.role === user.role);
            $scope.locationUsers[index >= 0 ? index : 1].users.push(user);
          });

          // Call Center availability check
          $scope.callCenter = angular.copy($scope.dataProvider.locationCallCenterResource.value);
          if ($scope.callCenter) {
            let callCenterStatus = $scope.callCenterStatuses.find(status => status.id === $scope.callCenter.status);
            $scope.callCenter.statusDesc = callCenterStatus ? $t(callCenterStatus.name) : $t('common.undefinedStatus');
          }
        }

        function onEditUserButtonClick(user) {
          utils.setStorageItem(SELECTED_USER_LOCAL_STORAGE_KEY, user);
          if (isUserEditable(user)) {
            $state.go('main.users.edit', {
              from: 'location'
            });
          } else {
            $state.go('main.users.view', {
              from: 'location'
            });
          }
          $rootScope.$emit('refreshChooseMenuEvent', 'users');
        }

        function onEditCallCenterButtonClick() {
          if ($scope.loading || !$scope.callCenter) {
            return;
          }

          utils.setStorageItem(SELECTED_CALLCENTER_LOCAL_STORAGE_KEY, $scope.callCenter);
          $state.go('main.callcenter.edit', {
            from: 'location',
            locationId: $scope.dataProvider.locationIdResource.value
          });
          $rootScope.$emit('refreshChooseMenuEvent', 'callcenter');
        }

        function isUserEditable(user) {
          return PermissionsService.canIEditUser(user);
        }

        function onConfigureUserAccessButtonClick(user) {
          if (!user || $scope.loading || $scope.usersSearching) {
            return;
          }

          $scope.selectedAccessId = user.locationAccess;
          $scope.selectedCategoryId = user.category || 0;
          $scope.selectedLocationUserRoleId = user.role || 0;
          $scope.selectedAccessUser = user;

          $('#user-access-modal').modal({
            autofocus: false
          }).modal('show');
        }

        function onSaveAccessConfigButtonClick() {
          $('#user-access-modal').modal('hide');
          $scope.loading = true;

          return $scope.dataProvider.updateLocationUserAccess(
            $scope.selectedAccessUser.id,
            $scope.selectedAccessId,
            $scope.selectedCategoryId,
            $scope.selectedAccessUser.temporary,
            $scope.selectedLocationUserRoleId
          )
            .then(() => {
              $scope.loading = false;
              $scope.selectedAccessId = undefined;
              $scope.selectedCategoryId = undefined;
              $scope.selectedLocationUserRoleId = undefined;
              $scope.selectedAccessUser = undefined;
            }, err => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function searchUsers(searchTerm, scrollFix) {
          if ($scope.loading || $scope.usersSearching || !searchTerm) {
            return;
          }
          $scope.usersSearching = true;
          $scope.lastSearchTerm = searchTerm;
          $scope.scrollFix = !!scrollFix;
          delete $scope.hideSearchHint;
          delete $scope.userExist;

          return $scope.dataProvider.searchUsersForLocation(searchTerm, SEARCH_USER_LIMIT)
            .then((users) => {
              $scope.userExist = !!users.usersExists;
              $scope.usersSearching = false;
              $scope.searchUserList = users;
              return $scope.searchUserList;
            })
            .catch(err => {
              $scope.usersSearching = false;
              $scope.userExist = undefined;
              $scope.searchUserList = undefined;
              utils.handleApiError(err);
            });
        }

        function addUser(userId) {
          if ($scope.loading || $scope.usersSearching || !userId || !$scope.searchUserList) {
            return;
          }

          let selectedUser = $scope.searchUserList.find(u => u.id === userId);
          if (!selectedUser) {
            return;
          }

          $scope.loading = true;
          $scope.usersSearching = true;
          return $scope.dataProvider.addUserToLocation(selectedUser)
            .then(() => {
              $scope.loading = false;
              $scope.usersSearching = false;
              $scope.searchUserList = $scope.searchUserList?.filter(u => u.id !== userId);

              // Search user again if server has more users to show
              if ($scope.searchUserList.size + 1 >= SEARCH_USER_LIMIT) {
                return searchUsers($scope.lastSearchTerm);
              }
            })
            .catch(err => {
              $scope.loading = false;
              $scope.usersSearching = false;
              utils.handleApiError(err);
            });
        }

        function onAddUserButtonClick() {
          // Focus input inside of userLookup directive
          $('#' + SEARCH_USER_FORM_ID).form('clear');
          $('#' + SEARCH_USER_INPUT_ID).trigger('focus');
        }

        function onRemoveUserButtonClick(user) {
          $('#remove-user-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              $('#remove-user-dialog').modal('hide');
              removeUserFromLocation(user);
            }
          }).modal('show');
        }

        function removeUserFromLocation(user) {
          $scope.loading = true;
          return $scope.dataProvider.removeLocationUser(user.id)
            .then(() => {
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            })
            .then(() => {
              return searchUsers($scope.lastSearchTerm);
            });
        }

        function getUserAccessDetails(user) {
          if (!user) {
            return '';
          }
          return [
            user.locationAccess != null ? $t('locations.accessLevels.' + user.locationAccess + '.name') : undefined,
            user.category != null ? $t('locations.categories.' + user.category + '.name') : undefined,
            user.role != null && Number.isInteger(user.role)
              ? $t('users.locationUserRole.' + user.role)
              : $t('users.locationUserRole.0'),
          ]
            .filter(e => !!e)
            .join(' / ');
        }
      }
    };
  })
  .name;
